module.exports = __webpack_public_path__ + "static/img/tempBg.3952d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tempBg.png
// module id = E2Bz
// module chunks = 2